export default __webpack_public_path__ + "static/media/angpao-cn.cd9eeb86.webp";